import { createAction, props } from '@ngrx/store';

import { AffiliateOption } from '@shared/services/affiliate/_interfaces_/affiliate-options.interface';

export const SET_AFFILIATE_OPTIONS = '[affiliate options] Set';

export const setAffiliateOptions = createAction(SET_AFFILIATE_OPTIONS, props<{ data: AffiliateOption[] }>());
